import { withHomeContext, withAppContext } from '@/config/site'
import request from '@/utils/request'

export const fetchHomeIndex = async (payload = {}) => {
  const response = await request('/page/home/index', {
    data: withHomeContext(payload)
  })

  return response.data || {}
}

export const fetchCourseCategories = async (payload = {}) => {
  const response = await request('/page/home/course-category', {
    data: withAppContext(payload)
  })

  return Array.isArray(response.data) ? response.data : []
}
